"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ERROR_CODE = void 0;
var ERROR_CODE = {
  NO_ACCESS_RIGHTS_TO_WORKSPACE: 'NO_ACCESS_RIGHTS_TO_WORKSPACE',
  RECAPTCHA_TOKEN_MISSING: 'RECAPTCHA_TOKEN_MISSING',
  RECAPTCHA_API_ERROR: 'RECAPTCHA_API_ERROR'
};
exports.ERROR_CODE = ERROR_CODE;